module.exports = __webpack_public_path__ + "b4e1f76f74603f8c17ccc552ccf004e8.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-lightitalic.woff
 ** module id = 6
 ** module chunks = 0
 **/